<template>
    <v-card-text>
        <title-card title="Sample balancing" help="quotas">

            <v-alert type="info"
                     prominent
                     icon="mdi-information"
                     dismissible
                     class="body-2 mb-8"
                     @input="closeAlert"
                     v-show="segmentCreated && alertVisible">
                Sample balancing is optional and can be used to drive more accurately for demanding projects
            </v-alert>

            <v-alert type="warning" prominent icon="mdi-information" class="body-2"
                     v-show="!segmentCreated">
                You must select the qualifications segment before you can balance your sample.
            </v-alert>

            <v-switch v-if="segmentCreated" v-model="quotasEnabledModel"
                      label="Balance sample"
                      class="pt-0 pl-8"
            ></v-switch>

            <v-slide-y-transition>

                <quota-tree v-show="quotasEnabledModel"
                            :project="project"
                            :enabled="quotasEnabledModel"
                            :target-completes="project.target_completes"
                            mode="create"
                            @change="quotasChanged"
                ></quota-tree>

            </v-slide-y-transition>
        </title-card>
    </v-card-text>
</template>

<script>

import Json from 'vue-json-pretty';
import QuotaTree from "../QuotaTree";
import TitleCard from "../../../../../components/UI/TitleCard";

export default {

    components: {
        Json,
        QuotaTree,
        TitleCard
    },

    props: {
        project: {
            required: true,
            type: Object,
        },
        errorMessages: {
            required: false,
            type: Object,
            default: () => {
                return {
                    name: []
                }
            }
        },
    },

    computed: {
        quotasEnabledModel: {
            get() {
                return this.project.quotas_enabled;
            },
            set(value) {
                this.$emit('change:project', {quotas_enabled: value})
            }
        },

        segmentCreated() {
            return this.project.json_query.conditions[0].dataVariableId;
        },

        alertVisible() {
            return !localStorage.getItem('sampleBalancingAlert');
        }
    },

    methods: {

        closeAlert() {
            localStorage.setItem('sampleBalancingAlert', JSON.stringify(false));
        },

        quotasChanged(quotas) {

            if (quotas.length === 0) {
                this.$emit('change:project', {quotas_enabled: false})
            }

            this.$emit('change', quotas);
        },
    }
}
</script>
